import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'

import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'
import Box from '../Layout/Box'


import {
    updateInputs,
    recomendarCotizacion,
    addCotizacionAprobar,
    seleccionarCotizacionAprobar,
} from '../../actions/solicitudservicio'

import { isAllowedToViewComponent, getDivisa, formatcoin } from '../../utils/helpers'


import { downloadFile, getParameterByName } from '../../actions/common'
import { isNull } from 'util';




class Cotizaciones extends Component {



    componentWillMount() {
        this.props.getParameterByName('FORMAS_PAGO')
    }

    
    getTotal = (valor, iva, cantidad) => {
        const total = valor*cantidad
        return iva ? total+((iva*total)/100) : total
    }


   
    handleOpenSelectorMoneda = (moneda,n) => {
        const cotizaciones = this.props.solicitudservicio.getIn(['servicios',n,'cotizaciones']);
        cotizaciones.map((c,i) => {
            this.props.updateInputs(`solicitud.servicios.${n}.cotizaciones.${i}.moneda`,moneda)
        })
    }


	render() {

        const { solicitudservicio, formaspago, divisas } = this.props


		return (

            <BoxSection title="Comparativo de cotizaciones">
                {
                    solicitudservicio.get('servicios').map((x, n) => {

                        const cotizacionesDisponibles = x.get('cotizaciones').filter(c => c.get('estado') >= 3 && c.get('proveedor_id') !== null)
                        const cotizacionesCompraDirecta = x.get('cotizaciones').filter(c => c.get('estado') >= 3 && c.get('proveedor_id') == null ) 
                        const readOnly = x.get('estado') == 0 || x.get('estado') >= 2 || !isAllowedToViewComponent('responsable_compras', this.props.solicitudservicio)
                        const moneda = x.get('cotizaciones') && x.get('cotizaciones').count() > 0 ? x.get('cotizaciones').first().get('moneda') : 'COP'
                        const divisa = getDivisa(divisas, moneda)


                        return [

                            (n > 0) ? <div key={ `sep1[${n}]` } className="separator" /> : null,
                            (n > 0) ? <div key={ `sep2${n}]` } className="separator" /> : null,
                            (n > 0) ? <div key={ `sep3${n}]` } className="separator" /> : null,
                            (n > 0) ? <div key={ `sep4[${n}]` } className="separator" /> : null,


                            <Box key={ `bs[${n}]` } title={ `Servicio No ${n + 1}` }>

                                <div className="separator"></div>

                                <div className="row">
                                    <div className="col-md-12">


                                        <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                                            <thead>
                                                <tr>
                                                    <th style={{ maxWidth: '86%', padding:'0 10px' }}>Tipo de moneda:</th>
                                                    <th style={{textAlign:'right'}}>
                                                        <div style ={{alignItems:'flex-end'}} className="btn-group" role="group" aria-label="Basic outlined example">
                                                            {
                                                                divisas && divisas.map((d,i) => {
                                                                    return (
                                                                        <button key={`d[${i}]`} style={{borderRadius: '5px'}} onClick={() => this.handleOpenSelectorMoneda(d.get('CODIGO'),n)} type="button" className={ divisa.moneda == d.get('CODIGO') ? 'btn btn-primary' : 'btn btn-outline-primary' }>{ d.get('CODIGO') }</button>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>   


                                        <table className="table table-condensed table-bordered table-striped" id="comparativo-cotizaciones">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Servicio</th>
                                                    <td colSpan={4}>{ x.get('descripcion')  || '' }</td>
                                                    <th>Cantidad</th>
                                                    <td>{ x.get('cantidad')  || '' }</td>
                                                    <td>
                                                        <BoxButton key={`pa[${n}][0]`} size={14} name="plus-circle" title="Adicionar"
                                                            disabled={(x.get('cotizaciones_aprobar').count() == x.get('cotizaciones').count() ||x.get('cotizaciones_aprobar').count() >= 3 || (!cotizacionesDisponibles.count() && x.get('compra_directa') == 0))|| x.get('estado') == 0 || x.get('estado') >= 2 || ((x.get('cotizaciones_aprobar').count() == cotizacionesDisponibles.count() && x.get('compra_directa') == 0 ))|| readOnly }
                                                           // disabled={(x.get('cotizaciones_aprobar').count() >= 3 || (!cotizacionesDisponibles.count() && x.get('compra_directa') == 0)) || x.get('estado') == 0 || x.get('estado') >= 2 || (x.get('cotizaciones_aprobar').count() == cotizacionesDisponibles.count()) || readOnly }
                                                            onClick={() => this.props.addCotizacionAprobar(`solicitud.servicios.${n}.cotizaciones_aprobar`)} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th style={{ width: '20px'}} title={ "Recomendación" }>
                                                        <span className="fa fa-star" style={{"color": "goldenrod", "fontSize": "20px"}} ></span>
                                                    </th>
                                                    <th style={{ width: '15%'}} >Proveedor</th>
                                                    <th style={{ width: '10%'}}>Valor Unit. antes de IVA</th>
                                                    <th style={{ width: '5%'}}>% IVA</th>
                                                    <th style={{ width: '10%'}}>Valor total</th>
                                                    <th>Distribucón de cenco</th>
                                                    <th style={{ width: '15%'}}>Fecha de entrega</th>
                                                    <th style={{ width: '10%'}}>Forma de pago</th>                                                    
                                                    <th style={{ width: '7%'}}>Cotización</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    x.get('cotizaciones_aprobar').map((a, b) => {

                                                        const fileid = a.get('adjunto_id') ? a.getIn(['adjunto', 'id']) : null
                                                        const filename = a.get('adjunto_id') ? a.getIn(['adjunto', 'nombre']) : null

                                                        if (a.get('estado') < 3) return null;

                                                        return (
                                                            <tr key={`rc[${n}][${b}]`}>

                                                                <td style={{ verticalAlign: 'middle' }} >
                                                                    <input type="checkbox" checked={a.get('recomendado') || false } disabled={readOnly}
                                                                        onChange={(e) => this.props.recomendarCotizacion(n, b)} />
                                                                </td>

                                                                <td style={{ verticalAlign: 'middle' }}>
                                                                    <select className="form-control input-sm" value={a.get('id') || ''} disabled={readOnly}
                                                                        onChange={(e) => this.props.seleccionarCotizacionAprobar(e.target.value, n, b)}>
                                                                        <option value="" disabled>Seleccione proveedor</option>
                                                                        {
                                                                            cotizacionesDisponibles.map(cotizacion =>
                                                                                <option key={cotizacion.get('guid')} value={cotizacion.get('id')}>{cotizacion.getIn(['proveedore', 'nombre'])  ?
                                                                                    cotizacion.getIn(['proveedore', 'nombre'])
                                                                                    : ''
                                                                                }</option>
                                                                            )                                                                           
                                                                        }
                                                                        {
                                                                            cotizacionesCompraDirecta.map(cotizacion =>
                                                                                <option key={cotizacion.get('guid')} value={cotizacion.get('id')}>COMPRA DIRECTA</option>                                                                               
                                                                            )
                                                                        }
                                                                    </select>
                                                                </td>

                                                                <td style={{ verticalAlign: 'middle' }}>
                                                                    <input type="number" className="form-control input-sm" value={a.get('cotizado') || ''}
                                                                        onChange={(e) => this.props.updateInputs(`solicitud.servicios.${n}.cotizaciones_aprobar.${b}.cotizado`, e.target.value, b+1)}
                                                                        disabled={readOnly} />
                                                                </td>

                                                                <td style={{ verticalAlign: 'middle' }}>
                                                                    <input type="number" className="form-control input-sm" value={a.get('iva')}
                                                                        onChange={(e) => this.props.updateInputs(`solicitud.servicios.${n}.cotizaciones_aprobar.${b}.iva`, e.target.value, b+1)}
                                                                        disabled={readOnly} />
                                                                </td>

                                                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                                                                    {
                                                                        `${ formatcoin((this.getTotal(a.get('cotizado'), a.get('iva'), x.get('cantidad'))),divisa.simbolo) }`
                                                                    }
                                                                </td>

                                                                <td>
                                                                    <table className="table table-condensed table-bordered table-striped" id="dist-cenco" style={{ fontSize: '12px' }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Cenco</th>
                                                                                <th>%</th>
                                                                                <th>Valor</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                x.get('cencos').map((c, i) => {
                                                                                    const total = this.getTotal(a.get('cotizado'), a.get('iva'), x.get('cantidad'))
                                                                                    return (
                                                                                        <tr key={`cenco[${n}][${b}][${i}]`}>
                                                                                            <td>{c.get('codigo')}</td>
                                                                                            <td style={{ textAlign: 'right' }}>{c.getIn(['pivot', 'porcentaje'])}</td>
                                                                                            <td style={{ textAlign: 'right' }}>
                                                                                                { formatcoin( ((c.getIn(['pivot','porcentaje'])/100)*total), divisa.simbolo ) }
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </td>

                                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                    <input 
                                                                        type="date" 
                                                                        className="form-control input-sm" 
                                                                        disabled={readOnly}
                                                                        value={ moment(a.get('fecha_entrega')).format('YYYY-MM-DD') } 
                                                                        onChange={ (e) => this.props.updateInputs(`solicitud.servicios.${n}.cotizaciones_aprobar.${b}.fecha_entrega`, e.target.value, b+1) } 
                                                                    />
                                                                </td>

                                                                <td style={{ verticalAlign: 'middle' }}>
                                                                    <select className="form-control input-sm" value={a.get('forma_pago')  || '0'} disabled={readOnly || a.get('proveedore') == null}
                                                                        onChange={(e) => this.props.updateInputs(`solicitud.servicios.${n}.cotizaciones_aprobar.${b}.forma_pago`, e.target.value, b+1)} >
                                                                        <option value="0" disabled>Seleccione</option>
                                                                        {
                                                                            formaspago && formaspago.map((opt, iopt) => {
                                                                                
                                                                                return (
                                                                                    <option key={`opt[${n}][${b}][${iopt}]`} value={opt.get('NOMBRE') }> {opt.get('NOMBRE') } </option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                    
                                                                </td>
                                                                {
                                                                    a.get('adjunto_id') ? (
                                                                        <td style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'middle' }} onClick={a.get('adjunto') ? () => this.props.downloadFile(fileid, filename) : () => null}>
                                                                            <i className="fa fa-download"></i>
                                                                        </td>
                                                                    ) : (
                                                                            <td style={{ cursor: 'not-allowed', verticalAlign: 'middle' }}>
                                                                                <span>Sin archivo</span>
                                                                            </td>
                                                                        )
                                                                }

                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>                                        
                                    </div>
                                </div>    

                            </Box>
                        ]
                    })
                }

            </BoxSection>
		)
	}
}

function mapStateToProps(state) {
    return {
        solicitudservicio: state.solicitudservicio.get('solicitud'),
        formaspago: state.common.getIn(['parametros', 'FORMAS_PAGO']),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
        recomendarCotizacion: (indexServicio, indexCotizacionAprobar) => dispatch(recomendarCotizacion(indexServicio, indexCotizacionAprobar)),
        addCotizacionAprobar: (path) => dispatch(addCotizacionAprobar(path)),
        seleccionarCotizacionAprobar: (cotizacion_id, indexServicio, indexCotizacionAprobar) => dispatch(seleccionarCotizacionAprobar(cotizacion_id, indexServicio, indexCotizacionAprobar)),
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cotizaciones)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/Cotizaciones.jsx